import styles from '../home.module.scss'
import { motion } from "framer-motion"

export default function Features() {
    return(
        <div>
            <div id="features">
                <div style={{ textAlign: 'center', fontSize: '40px', textDecoration: 'underline' }}>
                    <p>Features</p>
                </div>
            </div>

            <div className={styles.featuresRight}>
                <motion.div 
                className={styles.featuresSize} 
                initial={{ opacity: 0, x: 10 }}  
                whileInView={{ opacity: 1, x: -10 }}
                transition={{ duration: 0.5 }}>
                    <p style={{ fontSize: '30px' }}><strong>1#</strong> Music control panel</p>
                    <p style={{ fontSize: '20px' }}>
                        With the code developed from <strong>
                        <a href="https://github.com/Adivise/NanoSpace" target="_blank" rel="noreferrer">
                            Adivise/NanoSpace
                            </a>
                        </strong>, we give you a very convenient music listening experience with a music control panel just enter the command d!control enable.
                    </p>
                </motion.div>
                <motion.div 
                initial={{ opacity: 0, x: -10 }}  
                whileInView={{ opacity: 1, x: 10 }}
                transition={{ duration: 0.5 }}>
                    <img src="/control_panel.svg" alt="Control Panel" className={styles.aiRight}/>
                </motion.div>
            </div>

            <div className={styles.featuresLeft}>
                <motion.div
                initial={{ opacity: 0, x: 10 }}  
                whileInView={{ opacity: 1, x: -10 }}
                transition={{ duration: 0.5 }}>
                    <img src="/audio.svg" alt="Audio" className={styles.aiLeft}/>
                </motion.div>
                <motion.div 
                className={styles.featuresSize}
                initial={{ opacity: 0, x: -10 }}  
                whileInView={{ opacity: 1, x: 10 }}
                transition={{ duration: 0.5 }}>
                    <div>
                        <p style={{ fontSize: '30px' }}><strong>2#</strong> Sound quality</p>
                        <p style={{ fontSize: '20px' }}>
                        With specially optimized code for listening to music on discord, combined with lavalink selection and thorough testing from system integration tests, we give you a music listening experience with the most seamless sound quality.
                        </p>
                    </div>
                </motion.div>
            </div>

            <div className={styles.featuresRight}>
                <motion.div 
                className={styles.featuresSize}
                initial={{ opacity: 0, x: 10 }}  
                whileInView={{ opacity: 1, x: -10 }}
                transition={{ duration: 0.4 }}>
                    <p style={{ fontSize: '30px' }}><strong>3#</strong> Various music filters</p>
                    <p style={{ fontSize: '20px' }}>
                    With 20+ music filters, we let you choose the type of sound you like like nightcore, vaporwave, dance to help you listen to music better and have more fun.
                    </p>
                </motion.div>
                <motion.div
                initial={{ opacity: 0, x: -10 }}  
                whileInView={{ opacity: 1, x: 10 }}
                transition={{ duration: 0.5 }}>
                    <img src="/filter.svg" alt="Filter" className={styles.aiRight}/>
                </motion.div>
            </div>

            <div className={styles.featuresLeft}>
                <motion.div
                initial={{ opacity: 0, x: 10 }}  
                whileInView={{ opacity: 1, x: -10 }}
                transition={{ duration: 0.5 }}>
                    <img src="/support.svg" alt="Support" className={styles.aiLeft}/>
                </motion.div>
                <motion.div 
                className={styles.featuresSize}
                initial={{ opacity: 0, x: -10 }}  
                whileInView={{ opacity: 1, x: 10 }}
                transition={{ duration: 0.5 }}>
                    <div>
                        <p style={{ fontSize: '30px' }}><strong>4#</strong> Enthusiastic support</p>
                        <p style={{ fontSize: '20px' }}>
                        If anything is too difficult contact me via discord by <a href="https://discord.gg/uxbwPDtYq8">
                            <strong>
                            clicking here
                            </strong>
                        </a>, join the group and ask the support team as well as me.
                        </p>
                    </div>
                </motion.div>
            </div>

        </div>
    )
}